import React, { useEffect, useState } from "react";

import { GrantsAndIncentivesContext } from "common/contexts";

import Title from "components/atoms/Title";
import StepBar from "components/molecules/StepBar/index";
import { scrollTop } from "components/templates/hk/guide-and-tool/hong-kong-cost-planning-tool/index";

import StartScreenGrantsIncentives from "./StartScreen/index";
import Step2 from "./step2/index";
import Step3 from "./step3/index";
import Step1 from "./step1";

import styles from "./Index.module.scss";

const dataStep = [
  {
    id: 1,
    name: "Grants & Incentives Qualifying",
    sub_step: [],
  },
  {
    id: 2,
    name: "Company Information",
    sub_step: [],
  },
  {
    id: 3,
    name: "Suggested Grants & Incentives",
    sub_step: [],
  },
];

function GrantsAndIncentives({ data }) {
  const [step, setStep] = useState(1);
  const [firstScreen, setFirstScreen] = useState(true);
  const [userData, setUserData] = useState({});
  const [dataStep1, setDataStep1] = useState({});
  const [dataStep2, setDataStep2] = useState({});

  const reset = () => {
    setDataStep1({});
    setDataStep2({});
    setFirstScreen(false);
    setStep(1);
  };

  useEffect(() => {
    scrollTop();
  }, [step]);

  return (
    <GrantsAndIncentivesContext.Provider
      value={{
        step,
        setStep,
        firstScreen,
        setFirstScreen,
        userData,
        setUserData,
        dataStep1,
        setDataStep1,
        dataStep2,
        setDataStep2,
        reset,
      }}
    >
      {firstScreen ? (
        <StartScreenGrantsIncentives />
      ) : (
        <div className="relative bg-white lg:bg-transparent">
          <div className="container-fluid md:container ">
            <div className={`${styles.wrapper}`}>
              <Title className="mb-10 text-center text-bbc-30px font-semibold text-bbc-brand-700">
                Singapore
                <br />
                Grants & Incentives
              </Title>
              <div className="mb-10">
                <StepBar step={step} data={dataStep} />
              </div>
              {step === 1 && <Step1 data={data.step1} />}
              {step === 2 && <Step2 data={data.step2} />}
              {step === 3 && <Step3 data={data.step3} />}
            </div>
          </div>
          <div
            className="absolute z-10  w-full bg-white lg:hidden"
            style={{ height: "200px", bottom: "-200px" }}
          ></div>
        </div>
      )}
    </GrantsAndIncentivesContext.Provider>
  );
}

export default GrantsAndIncentives;
